<template>
    <el-select
        v-model="selectedService"
        @input="$emit('input', selectedService)"
        @change="$emit('change', selectedService)"
    >
        <el-option
            v-for="option in expiredServiceOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
        />
    </el-select>
</template>

<script>

export default {
  name: 'StatusFilter',
  props: {
    value: {
      type: [Boolean, String],
      default: 'active',
    },
  },
  data() {
    return {
      selectedService: this.value,
      expiredServiceOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
        { label: 'All', value: 'all' }
      ],
    };
  },
  watch: {
    value(newValue) {
      this.selectedService = newValue;
    },
  },
};
</script>
